import { render, staticRenderFns } from "./CostBearersBalanceTop.vue?vue&type=template&id=24a826f2&"
import script from "./CostBearersBalanceTop.vue?vue&type=script&lang=ts&"
export * from "./CostBearersBalanceTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports